import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import type { FolderResponseDto } from '@inference.engine/workspace-api-client/web';

import { notificationService } from '@/lib/services/notification.service';

import { setProjectFolderThumbnail } from './project-folders.api';

export { setProjectFolderThumbnail };

interface UseSetFolderThumbnailOptions {
  projectId: string;
  folderId: string;
  onSuccess?: () => void;
}

export function useSetFolderThumbnail(options: UseSetFolderThumbnailOptions) {
  const { projectId, folderId, onSuccess } = options;
  const { t } = useTranslation('projects');
  const queryClient = useQueryClient();

  return useMutation<FolderResponseDto, Error, string | null>({
    mutationFn: (assetId) => setProjectFolderThumbnail(projectId, folderId, assetId),
    onSuccess: () => {
      notificationService.showSuccess(
        t('manageProjectFolders.useSetFolderThumbnail.folderThumbnailUpdated'),
      );
      void queryClient.invalidateQueries({
        queryKey: ['project', projectId, 'folders'],
      });
      onSuccess?.();
    },
    onError: (error: unknown) => {
      const message =
        error instanceof Error
          ? error.message
          : t('manageProjectFolders.useSetFolderThumbnail.couldNotUpdateThumbnail');
      notificationService.showError(message);
    },
  });
}
